import { render, staticRenderFns } from "./LogsTab.vue?vue&type=template&id=6e2743e0&scoped=true&"
import script from "./LogsTab.vue?vue&type=script&lang=js&"
export * from "./LogsTab.vue?vue&type=script&lang=js&"
import style0 from "./LogsTab.vue?vue&type=style&index=0&id=6e2743e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2743e0",
  null
  
)

export default component.exports